import prodConfig from './prod'
import stageConfig from './stage'
import devConfig from './dev'

const configs = {
  prod: prodConfig,
  stage: stageConfig,
  dev: devConfig,
}

export default configs[window.serviceEnv]
